import { render, staticRenderFns } from "./SwitchMapModeButton.vue?vue&type=template&id=baa46574"
import script from "./SwitchMapModeButton.vue?vue&type=script&lang=ts"
export * from "./SwitchMapModeButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports